import { useState } from 'react';
import { ResponseError, Wishlist } from '@ynap/api-utils';
import { useConfig, useAppState } from '@ynap/immutables-provider';
import { raygun } from '@ynap/clientside-monitoring';

const configSelector = (config) => ({
    baseUrl: config.global?.services.commerce.baseUrl,
    brandId: config.global?.application.brandId,
    clientId: config.global?.services.commerce.clientId,
});

export const useWishList = (uberToken) => {
    const [wishList, setWishList] = useState();
    const { country } = useAppState() || {};
    const { baseUrl, brandId, clientId } = useConfig(configSelector);

    const addToWishList = async (partNumber, item) => {
        try {
            const response = await window.SF.addToWishlist([{ partNumber, ...item }]);
            if (!response.success) {
                raygun.helpers.agent('send', {
                    error: new Error(`addToWishlist in useWishlist Hook`),
                    tags: [`error-addToWishlist`, `partNumber: ${partNumber}`, `statusCode: ${response.status}`],
                });
            }
            return response;
        } catch (err) {
            raygun.helpers.agent('send', {
                error: new Error(`addToWishlist in useWishlist Hook`),
                tags: [`error-addToWishlist`, `partNumber: ${partNumber}`],
                customData: {
                    err,
                },
            });

            if (`${err}`.includes('uberToken')) {
                throw new Error('uberToken required');
            } else {
                throw new Error('Failed to add to wishlist');
            }
        }
    };

    const getWishList = async (wishlistId = '@default') => {
        const params = {
            baseUrl,
            brandId,
            country,
            clientId,
            uberToken,
            wishlistId,
        };
        try {
            const request = Wishlist.getWishlist(params);
            const response = await fetch(request);
            if (!response.ok) {
                raygun.helpers.agent('send', {
                    error: new Error(`getWishList in useWishlist Hook`),
                    tags: [`error-getWishList`, `wishlistId: ${wishlistId}`, `statusCode: ${response.status}`],
                });
                throw new ResponseError(response);
            }
            const json = await response.json();
            setWishList(json?.GiftList?.[0]);
            return json;
        } catch (err) {
            raygun.helpers.agent('send', {
                error: new Error(`getWishList in useWishlist Hook`),
                tags: [`error-getWishList`, `wishlistId: ${wishlistId}`],
                customData: {
                    err,
                },
            });
            throw new Error('Failed to get to wishlist');
        }
    };

    return {
        addToWishList,
        getWishList,
        wishList,
    };
};
